import React from 'react';
import {Navigate, Route, Routes} from "react-router-dom";
import Home from "./home";
import 'styles/global.scss';
import NavBar from 'component/NavBar';
import Work from "./work";

function App() {
    return (
        <>
            <header>
                <h1>
                    David Black
                </h1>

                <NavBar/>
            </header>
            <div style={{
                padding: 10,
                width: '100%',
                height: '100%',
            }}
            >
                <Routes>
                    <Route path='/' element={<Navigate to={'/home'}/>}/>
                    <Route path="/home" element={<Home/>}/>
                    <Route path="/work" element={<Work/>}/>
                </Routes>
            </div>
        </>
    );
}

export default App;
